// mox-gate-cta.js — v3.3: hover/ click consistentes y SOLO click al botón del header
(function () {
  'use strict';

  // Fuente base (no cambio llaves existentes)
  const G = window.MOX_GATE || { state: 'guest' };

  // === Estado canónico ===
  // Uso MOX_GATE.state si es válido; si no, lo deduzco (logueo por body[data-customer-id], registro por MOX_GATE.isRegistered)
  const state = () => {
    const g = window.MOX_GATE || {};
    const v = g.state;
    if (v === 'guest' || v === 'need_register' || v === 'eligible') return v;

    const logged = !!document.body?.dataset?.customerId;
    if (!logged) return 'guest';
    return g.isRegistered ? 'eligible' : 'need_register';
  };

  // Textos de hover
  const LABELS = { guest: 'Iniciar sesión', need_register: 'Regístrate ahora', eligible: 'Agregar' };

  // Nuestro CTA + submit nativo del theme en cards/PDP
  const CTA_SEL = '[data-mox-card-cta], form[action*="/cart/add"] [type="submit"][name="add"]';

  // ---------- helpers ----------
  const isEl = (n) => n && n.nodeType === 1;
  const closest = (el, sel) => {
    let node = isEl(el) ? el : el?.parentElement || null;
    while (isEl(node)) { if (node.matches?.(sel)) return node; node = node.parentElement; }
    return null;
  };
  const getBtn = (e) => closest(e.target, CTA_SEL);
  const getForm = (btn) => btn?.closest('form') || null;
  const getVariantId = (btn) => getForm(btn)?.querySelector('input[name="id"]')?.value?.trim() || null;

  // Aseguro un elemento de label estable (.mox-cta-label) sin perder referencia
  function ensureLabelEl(btn) {
    if (!btn) return null;
    let el = btn.querySelector('.mox-cta-label');
    if (el) return el;
    el = document.createElement('span');
    el.className = 'mox-cta-label';
    const txt = (btn.textContent || '').trim();
    el.textContent = txt || 'Agregar';
    btn.replaceChildren(el);
    return el;
  }

  // Botón del header (usuario/login) — NO abrimos modales nosotros, solo disparamos su click
  const getHeaderLoginBtn = () =>
    document.querySelector(
      '#mox-login-trigger, button[data-open-auth-icon="login"], .hdt-site-nav_user button, a[aria-controls="login-form-popup"]'
    );

  // Sustituye la versión actual por esta
const clickHeaderLoginSafely = () => {
  const t = getHeaderLoginBtn();
  if (!t) return false;

  // Si es <a>, evitamos navegación SOLO en este disparo
  if (t.tagName === 'A') {
    t.addEventListener('click', (e) => e.preventDefault(), { once: true, capture: true });
  }

  // Defer en microtarea: evita el re-toggle en el mismo ciclo de click del CTA
  Promise.resolve().then(() => {
    try {
      // usar .click() es suficiente; si prefieres, podrías disparar un MouseEvent
      t.click();
    } catch (_) {}
  });

  return true;
};


  // ---------- hover (uso mouseover/mouseout porque burbujean) ----------
  document.addEventListener('mouseover', (e) => {
    const btn = getBtn(e); if (!btn) return;
    const el = ensureLabelEl(btn);
    btn.dataset._prev = el.textContent;
    el.textContent = LABELS[state()] || el.textContent;
  }, true);

  document.addEventListener('mouseout', (e) => {
    const btn = getBtn(e); if (!btn) return;
    const el = ensureLabelEl(btn);
    if (btn.dataset._prev) el.textContent = btn.dataset._prev;
  }, true);

  // Bloqueo del submit nativo a /cart/add (manejamos nosotros el flujo)
  document.addEventListener('submit', (e) => {
    if (closest(e.target, 'form[action*="/cart/add"]')) e.preventDefault();
  }, true);

  // ---------- click ----------
  document.addEventListener('click', (e) => {
    const btn = getBtn(e); if (!btn) return;

    // Anti doble click
    if (btn.dataset.busy === '1') { e.preventDefault(); return; }
    btn.dataset.busy = '1'; setTimeout(() => (btn.dataset.busy = '0'), 500);

    const st = state();

    if (st === 'eligible') {
      // Agregar solo si hay talla/variant
      e.preventDefault();
      const vid = getVariantId(btn);
      if (!vid) {
        const el = ensureLabelEl(btn), prev = el.textContent;
        el.textContent = 'Selecciona talla';
        setTimeout(() => (el.textContent = prev), 1100);
        getForm(btn)
          ?.querySelector('input[type="radio"], button[aria-pressed], [data-size], [data-option]')
          ?.focus?.();
        return;
      }
      document.dispatchEvent(new CustomEvent('mox:shadow:add', {
        detail: { variantId: vid, quantity: 1, source: 'card' }
      }));
      return;
    }

    // guest / need_register → NO navegamos ni abrimos modal a mano; solo clic al botón del header
    // guest / need_register → abrir modal de login a través del botón del header
    e.preventDefault();

    const btnCta   = getBtn(e);
    const hayLogin = !!getHeaderLoginBtn();

  // Sólo aislamos el click si REALMENTE vamos a abrir el modal
    if (btnCta && hayLogin) {
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      clickHeaderLoginSafely();
    } else {
      // Si por alguna razón no hay botón de login, no bloqueamos otros handlers
      // (opcionalmente podrías dejar un log aquí)
    }

  }, true);
})();
